import { GET_HISTORY_DATA_VALIDATION } from 'fixtures/actions';
import { DATA_VALIDATION } from 'fixtures/api';
import { getAllList } from 'services/cmsService';

export const getAllHistoryDataValidation = (params) => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(`${DATA_VALIDATION}?${params}`)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_HISTORY_DATA_VALIDATION,
      payload: data
    })
  }
}